/*
 * @Author: your name
 * @Date: 2021-10-27 14:23:02
 * @LastEditTime: 2022-05-06 15:23:49
 * @LastEditors: haima haima@yaomaitong.cn
 * @Description: In User Settings Edit
 * @FilePath: /ksh-doctor/src/store/index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import indexPage from './modules/indexPage'
import user from './modules/user'
import shop from './modules/shop'
import conference from './modules/conference'
import patient from './modules/patient'
import live from './modules/live'
import payModule from './modules/payParams'
import help from './modules/help'
import mutation from './mutation'
import intellectual from './modules/intellectual'
import keepAlive from './modules/keepAlive'
import common from './modules/common'
import contract from './modules/contract'
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	modules: {
		index: indexPage,
		user: user,
		shop: shop,
		patient: patient,
		live: live,
		payModule: payModule,
		conference: conference,
		help: help,
		intellectual: intellectual,
    keepAlive,
    common,
    contract
	},
	strict: debug
});
